import { render, staticRenderFns } from "./templateConfiguration.vue?vue&type=template&id=2bfba1ea&scoped=true"
import script from "./templateConfiguration.vue?vue&type=script&lang=js"
export * from "./templateConfiguration.vue?vue&type=script&lang=js"
import style0 from "./templateConfiguration.vue?vue&type=style&index=0&id=2bfba1ea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfba1ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfba1ea')) {
      api.createRecord('2bfba1ea', component.options)
    } else {
      api.reload('2bfba1ea', component.options)
    }
    module.hot.accept("./templateConfiguration.vue?vue&type=template&id=2bfba1ea&scoped=true", function () {
      api.rerender('2bfba1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/templateConfiguration.vue"
export default component.exports